import { useContext } from 'react';
import { OrderBasketContext } from '../../providers/OrderBasketProvider';

export default function useOrderBasket() {
  return useContext(OrderBasketContext);
}
